import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as PrepaidModule from '@Modules/cardManagementSystem/prepaid/pages';
import React from 'react';

const URL_GLOBAL_PARAMETERS = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.GLOBAL_PARAMETERS;
const URL_CARD = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.CARD;
const URL_PREPAID_OPERATIONS = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.PREPAID_OPERATIONS;
const URL_COMPANY = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.COMPANY;
const URL_CARD_HOLDER = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.CARD_HOLDER;

const PrepaidRoutes = [
  // Global Parameters MENU ROUTES
  <Route>
    {globalParametersMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Card  MENU ROUTES
  <Route>
    {cardMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Prepaid Operations  MENU ROUTES
  <Route>
    {prepaidOperationsMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Company  MENU ROUTES
  <Route>
    {companyMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
  // Card Holders MENU ROUTES
  <Route>
    {cardHoldersMenuRoutes().map((oneRoute, index) => (
      <React.Fragment key={index}>{oneRoute}</React.Fragment>
    ))}
  </Route>,
];

function globalParametersMenuRoutes() {
  return [
    <Route
      path={URL_GLOBAL_PARAMETERS.AUTOMATIC_RECHARGE_STOP_REASON}
      element={<PrepaidModule.AutomaticRechargeStopReason />}
    />,
    <Route
      path={URL_GLOBAL_PARAMETERS.RECHARGE_FEES}
      element={<PrepaidModule.RechargeFees />}
    />,
    <Route
      path={URL_GLOBAL_PARAMETERS.MISCELLANEOUS_PERIODIC_COSTS}
      element={<PrepaidModule.MiscellaneousPeriodicCosts />}
    />,
    <Route
      path={URL_GLOBAL_PARAMETERS.ANONYMOUS_CARD_AGENCY_ACCOUNT}
      element={<PrepaidModule.AnonymousCardAgencyAccount />}
    />,
  ];
}

function cardMenuRoutes() {
  return [
    <Route
      path={URL_CARD.ANONYMOUS_CARD_PRODUCTION}
      element={<PrepaidModule.AnonymousCardProduction />}
    />,
    <Route
      path={URL_CARD.CONSULT_ANONYMOUS_CARD}
      element={<PrepaidModule.ConsultAnonymousCard />}
    />,
    <Route
      path={URL_CARD.CONSULT_PREPAID_TRANSACTION}
      element={<PrepaidModule.ConsultPrepaidTransaction />}
    />,
    <Route
      path={URL_CARD.CONSULT_PREPAID_TRANSACTION_DETAILS + ':id/'}
      element={<PrepaidModule.ConsultPrepaidTransactionDetails />}
    />
    
  ];
}

function prepaidOperationsMenuRoutes() {
  return [
    <Route
      path={URL_PREPAID_OPERATIONS.MANUAL_CARD_TOP_UP}
      element={<PrepaidModule.ManualCardTopUp />}
    />,
    <Route
      path={URL_PREPAID_OPERATIONS.ENABLE_AUTOMATIC_RECHARGE}
      element={<PrepaidModule.EnableAutomaticRecharge />}
    />,
    <Route
      path={URL_PREPAID_OPERATIONS.DISABLE_AUTOMATIC_RECHARGE}
      element={<PrepaidModule.DisableAutomaticRecharge />}
    />,
  ];
}

function companyMenuRoutes() {
  return [
    <Route
      path={URL_COMPANY.COMPANY_DATA}
      element={<PrepaidModule.CompanyData />}
    />,
    <Route
      path={URL_COMPANY.SALARY_FILE}
      element={<PrepaidModule.SalaryFile />}
    />,
    <Route
      path={URL_COMPANY.SALARY_FILE_DETAILS}
      element={<PrepaidModule.SalaryFileDetails />}
    />,
  ];
}

function cardHoldersMenuRoutes() {
  return [
    <Route
      path={URL_CARD_HOLDER.PREPAID_PROGRAM}
      element={<PrepaidModule.PrepaidProgram />}
    />,
    <Route
      path={URL_CARD_HOLDER.PREPAID_APPLICATION.PREPAID_APPLICATION}
      element={<PrepaidModule.PrepaidApplication />}
    />,
    <Route
      path={URL_CARD_HOLDER.PREPAID_APPLICATION.CONSULT_PREPAID_APPLICATION}
      element={<PrepaidModule.ConsultPrepaidApplication />}
    />,
    <Route
      path={URL_CARD_HOLDER.PREPAID_APPLICATION_VALIDATION}
      element={<PrepaidModule.PrepaidApplicationValidation />}
    />,
    <Route
      path={URL_CARD_HOLDER.ANONYMOUS_CARD_HOLDER}
      element={<PrepaidModule.AnonymousCardHolder />}
    />,
    <Route
      path={URL_CARD_HOLDER.CONSULT_PREPAID_DATA}
      element={<PrepaidModule.ConsultPrepaidData />}
    />,
    <Route
      path={URL_CARD_HOLDER.CHANGE_ANONYMOUS_CARD_AGENCY}
      element={<PrepaidModule.ChangeAnonymousCardAgency />}
    />,
  ];
}


export default PrepaidRoutes;
